import { dwCollect } from '@/utils/dw-collect';

/**
 * dw Hover【入门指引】
 *
 */
export const dwOnHelpIconHover = () => {
  dwCollect({ element: 'help', module: 'more', action: 'hover' });
};

/**
 * dw Hover【入门指引】面板展示
 *
 */
export const dwOnHelpPopoverShow = () => {
  dwCollect({ element: 'help', module: 'more', action: 'show' });
};

/**
 * dw 点击教程
 *
 */
export const dwOnHelpClick = (key1 = '') => {
  dwCollect({ element: 'help', module: 'more', action: 'click', key1 });
};

/**
 * dw 咨询二维码曝光展示
 *
 */
export const dwOnHelpQrCodeShow = () => {
  dwCollect({ element: 'qrcode', module: 'more', action: 'show' });
};

/**
 * dw 点击【用户反馈】
 *
 */
export const dwOnHelpUserFeedbackClick = () => {
  dwCollect({ element: 'user_feedback', module: 'more', action: 'click' });
};

/**
 * dw 点击【收起】
 *
 */
export const dwOnHelpCloseClick = () => {
  dwCollect({ element: 'collapse', module: 'more', action: 'click' });
};

/**
 * Hover【更多】
 *
 */
export const dwOnHelpMoreHover = () => {
  dwCollect({ element: 'more', module: 'more', action: 'click' });
};
